export default "__VITE_ASSET__8f29a9d3__"